import { render } from "./GeneralTabs.vue?vue&type=template&id=0f9e12af"
import script from "./GeneralTabs.vue?vue&type=script&lang=js"
export * from "./GeneralTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__